import { render, staticRenderFns } from "./employee-details.vue?vue&type=template&id=1794a9a4&scoped=true&lang=pug"
import script from "./employee-details.vue?vue&type=script&lang=ts"
export * from "./employee-details.vue?vue&type=script&lang=ts"
import style0 from "./employee-details.vue?vue&type=style&index=0&id=1794a9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794a9a4",
  null
  
)

export default component.exports